import { Recipient } from '@bonusly/recipient-entities';

import { EmployeeSpotlightAttachment, ImageAttachment, SocialAttachment, VideoAttachment } from '../../action-input/lib/entities/attachment';

export enum GiveBoxEvent {
	Created = 'bonus-created',
	Deleted = 'bonus-deleted',
	Open = 'init-give-recognition',
}

export type GiveBoxAttachment = SocialAttachment | ImageAttachment | VideoAttachment | EmployeeSpotlightAttachment;

// Type definition for GiveBoxEvent.Open event data
export interface GiveBoxOpenEventData {
	recipient?: Recipient;
	text?: string;
	amount?: number;
	hashtags?: string[];
	attachment?: GiveBoxAttachment;
	/** When true, text was AI-generated and should be highlighted with the suggestion-highlight mark. */
	aiGenerated?: boolean;
	/** Pre-built TipTap JSON content -- when provided, used directly instead of building from text/recipient/amount/hashtags. */
	editorContent?: unknown;
	/**
	 * AI-drafted content to insert into the editor once the modal mounts,
	 * using `insertWithHighlight` so the text carries the AI-touched
	 * highlight until the user edits it. Used by Bizy's contextual `/`
	 * invocation to hand a draft back to the give box after the modal
	 * was closed for the Bizy session. See HABITS-1294.
	 */
	aiDraft?: string;
	/**
	 * When true, the give-box modal auto-submits the form after the
	 * draft is inserted (same as the user clicking Give). Used by the
	 * Bizy UI block `send_now` action on a recognition_draft_card so
	 * the user gets one-click send while still going through the
	 * normal submit path (validation, balance check, error surfacing).
	 * The modal mounts briefly; if validation fails, it stays open so
	 * the user can fix the issue. See HABITS-1294.
	 */
	autoSend?: boolean;
}
